import {
	confirmElectronicReceiptsHeaders,
	getActivationMissingOrders,
	getElectronicReceiptsHeaders,
	getFilterBranches,
	setElectronicReceiptsHeaderFilters
} from 'actions'
import NotificationMessage from 'components/common/notificationMessage'
import { API_FORMAT_DATE } from 'constants/ApiFormats'
import { P_ACTIVATION_MISSING_ORDERS } from 'constants/ConfigProcessNames'
import { addPrevValidations } from 'lib/AxiosInterceptors'
import { getFiltersData } from 'lib/Utils'
import { IActivationMissingOrdersFormValues } from 'models/ActivationMissingOrders'
import moment from 'moment'
import React, { Component, forwardRef, Ref } from 'react'
import { Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import _ from 'underscore'
import ActivationMissingFilters from './ActivationMissingFilters'
import {
	IActivationMissingComponentProps,
	IActivationMissingComponentState
} from './ActivationMissingOrdersTypes'
import ActivationMissingTable from './ActivationMissingTable'
import { IRowsParams } from './ActivationMissingTable/ActivationMissingTableTypes'

class ActivationMissingOrdersComponent extends Component<
	IActivationMissingComponentProps,
	IActivationMissingComponentState
> {
	constructor(props: IActivationMissingComponentProps) {
		super(props)
		this.state = {
			messageError: '',
			showError: false,
			typeError: 'danger',
			filtersForm: {},
			rowSelected: []
		}

		addPrevValidations((e: any) => {
			if (e.request.responseURL.includes('/p_vta_act_faltas/consulta')) {
				return true
			}
			return false
		})
	}

	componentDidMount = () => {
		const { idOperacion } = this.props
		this.props.getActivationMissingOrders({
			idOperacion: idOperacion ?? '',
			page_number: 1,
			page_size: 10,
			fec_fin: '',
			fec_ini: '',
			Sucursal: ''
		})
		this.props.getFilterBranches({ idOperacion })
	}

	componentDidUpdate = (prevProps: IActivationMissingComponentProps) => {
		const { messageError } = this.props

		if (messageError !== prevProps.messageError && messageError) {
			const { message } = messageError
			const showError = true
			this.setState({
				showError,
				messageError: message
			})
		}
	}

	formatDate = (date: string) => {
		return date !== '' ? moment(date).format(API_FORMAT_DATE) : ''
	}

	/**
	 * call search api with filters params.
	 * @param filters
	 */
	handleFilterSearch = (filters: IActivationMissingOrdersFormValues) => {
		const { idOperacion } = this.props
		const { filtersForm } = this.state
		const fec_fin = this.formatDate(filters.fec_fin)
		const fec_ini = this.formatDate(filters.fec_ini)

		const params = {
			...filtersForm,
			...filters,
			fec_fin,
			fec_ini,
			page_size: 10,
			page_number: 1,
			idOperacion: idOperacion ?? ''
		}

		this.setState({ filtersForm: { ...params, ...filters } })

		this.props.getActivationMissingOrders(params)
	}

	/**
	 * close notification error
	 */
	handleCloseErrorNotification = () => {
		this.setState({ showError: false })
	}

	handleClearFilters = () => {
		const { idOperacion } = this.props

		this.setState({
			filtersForm: {
				idOperacion: idOperacion ?? '',
				page_number: 1,
				page_size: 10,
				Sucursal: '',
				fec_fin: '',
				fec_ini: ''
			}
		})
	}

	/**
	 * to save selected rows
	 * @param param0
	 */
	handleSetRows = ({ rowSelected }: IRowsParams) => {
		this.setState({ rowSelected })
	}

	render() {
		const { config, idOperacion } = this.props
		const { showError, messageError, typeError, filtersForm, rowSelected } =
			this.state

		const fieldsFilter = config
			? getFiltersData(config.campos, { agrupador: 'formulario' })
			: []

		const fieldsTable = config
			? getFiltersData(config.campos, { agrupador: 'grilla' })
			: []

		const notificationsProps = {
			showError,
			errorMessage: messageError,
			type: typeError,
			handleCloseError: this.handleCloseErrorNotification
		}
		return (
			<Col className={`col-12`}>
				{!_.isEmpty(fieldsFilter) && (
					<ActivationMissingFilters
						initialState={filtersForm}
						fields={fieldsFilter}
						handleFilterSearch={this.handleFilterSearch}
						idOperacion={idOperacion ?? ''}
						clearFilters={this.handleClearFilters}
						rowSelected={rowSelected}
					/>
				)}
				<NotificationMessage {...notificationsProps} />
				<ActivationMissingTable
					fields={fieldsTable}
					idOperacion={idOperacion ?? ''}
					formFilters={filtersForm}
					handleSetRows={this.handleSetRows}
				/>
			</Col>
		)
	}
}

const mapStateToProps = ({ voucher, auth, electronicReceiptsItems }: any) => {
	const config = voucher.config
		? voucher.config[P_ACTIVATION_MISSING_ORDERS]
		: null
	const { authUser } = auth
	const {
		electronicReceiptsHeaders,
		confirmHeaders,
		messageError,
		confirmParams,
		headerFilters
	} = electronicReceiptsItems
	return {
		config,
		authUser,
		electronicReceiptsHeaders,
		confirmHeaders,
		messageError,
		confirmParams,
		headerFilters
	}
}

const mapDispatchToProps = {
	getElectronicReceiptsHeaders,
	getFilterBranches,
	setElectronicReceiptsHeaderFilters,
	confirmElectronicReceiptsHeaders,
	getActivationMissingOrders
}

const ActivationMissingOrdersComponentWithRef = forwardRef(
	function ActivationMissingFormWrapper(
		props: IActivationMissingComponentProps,
		ref: Ref<ActivationMissingOrdersComponent>
	) {
		return <ActivationMissingOrdersComponent {...props} ref={ref} />
	}
)

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(ActivationMissingOrdersComponentWithRef)
